<script lang="ts" setup>
import { storeToRefs } from 'pinia'
import Button from 'primevue/button'
import { computed, useAttrs, useSlots } from 'vue'
import { useAppStore } from '@/stores/app.store'

const props = defineProps<{
  showIconOnMobile?: boolean
}>()

const rawAttrs = useAttrs()
const slots = useSlots()

const { isMobile } = storeToRefs(useAppStore())

const includeIcon = computed<boolean>(
  () => (!isMobile.value || (isMobile.value && props.showIconOnMobile)) && !!rawAttrs.label && !!slots.icon,
)

const attrs = computed(() => {
  let newAttrs = { ...rawAttrs }
  if (isMobile.value && !!rawAttrs.label && !rawAttrs.size) {
    newAttrs = { ...rawAttrs, size: 'small' }
  }
  return newAttrs
})
</script>

<script lang="ts">
export default {
  inheritAttrs: false,
}
</script>

<template>
  <Button v-bind="attrs">
    <template
      v-if="slots.default"
      #default
    >
      <slot name="default" />
    </template>
    <template
      v-if="includeIcon"
      #icon
    >
      <slot name="icon" />
    </template>
    <template
      v-if="slots.loadingicon"
      #loadingicon
    >
      <slot name="loadingicon" />
    </template>
  </Button>
</template>
